export const ExactlyWithdrawalBanks = [
    { value: '2', label: 'BANGKOK BANK PUBLIC COMPANY LTD.' },
    { value: '4', label: 'KASIKORNBANK PCL.' },
    { value: '5', label: 'THE ROYAL BANK OF SCOTLAND PLC BKK BR' },
    { value: '6', label: 'KRUNG THAI BANK PCL.' },
    { value: '8', label: 'JPMORGAN CHASE BANK N.A. BANGKOK BRANCH' },
    { value: '9', label: 'OVERSEA-CHINESE BKG.CORP.' },
    { value: '10', label: 'BANK OF TOKYO-MITSUBISHI' },
    { value: '11', label: 'THANACHART THAI MILITARY BANK' },
    { value: '14', label: 'SIAM COMMERCIAL BANK PCL.' },
    { value: '17', label: 'CITIBANKN.A.' },
    { value: '18', label: 'SUMITOMO MITSUI BK.CORP.' },
    { value: '20', label: 'STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED' },
    { value: '22', label: 'CIMB THAI BANK PUBLIC COMPANY LIMITED' },
    { value: '23', label: 'RHB BANK BERHADBKK.BR.' },
    { value: '24', label: 'UOB (THAI) PCL.' },
    { value: '25', label: 'BANK OF AYUDHYA PCL.' },
    { value: '26', label: 'MEGA INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED' },
    { value: '27', label: 'BANK OF AMERICA NATIONAL ASSOCIATION' },
    { value: '29', label: 'INDIAN OVERSEA BANK' },
    { value: '30', label: 'GOVERNMENT SAVINGS BANK' },
    { value: '31', label: 'H.S.B.C.' },
    { value: '32', label: 'DEUTSCHE BANK AG.' },
    { value: '33', label: 'GOVERNMENT HOUSING BANK' },
    { value: '34', label: 'BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES' },
    { value: '35', label: 'EXPORT-IMPORT BANK OF THAILAND' },
    { value: '39', label: 'MIZUHO BANK LTD' },
    { value: '45', label: 'BNP PARIBAS BANGKOK BRANCH' },
    { value: '52', label: 'BANK OF CHINA' },
    { value: '66', label: 'ISLAMIC BANK OF THAILAND' },
    { value: '67', label: 'TISCO BANK PCL.' },
    { value: '68', label: 'AIG RETAIL BANK PCL.' },
    { value: '69', label: 'KIATNAKIN BANK PCL.' },
    { value: '70', label: 'ICBC (THAI)' },
    { value: '73', label: 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED' },
    { value: '79', label: 'ANZ BANK (THAI) PLC' },
    { value: '80', label: 'SUMITOMO MITSUI TRUST BANK (THAI) PUBLIC COMPANY LIMITED' },
    { value: '98', label: 'SMALL AND MEDIUM ENTERPRISE DEVELOPMENT BANK OF THAILAND' },
    { value: '111', label: 'PROMPTPAY BANK' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
export const exactlyBankAccountTypes = [
    { value: 'personal', label: 'Personal' },
    { value: 'company', label: 'Company' },
].reduce((obj, kv) => ({ ...obj, [kv.value]: { key: kv.value, ...kv } }), {});
